import * as React from 'react'
import { Link } from 'react-router-dom'
import cx from 'classnames'

const style = require('./Drawer.css')

interface LinkProps {
  children: React.ReactNode;
  to: string;
  reload?: boolean;
  skip?: boolean;
}

interface Props {
  children: React.ReactNode;
  shown: boolean;
  onClose: () => void;
  className?: string;
}

const Separator = () => <div className={style.separator} />

const LinkComponent = ({ to, children, reload, skip }: LinkProps) => (
  reload ? (
    <a href={to} className={cx(style.link, {'unii-skip': skip})}>
      <div className={style.linkContent}>{children}</div>
    </a>
  ) : (
    <Link to={to} href={to} className={cx(style.link, {'unii-skip': skip})}>
      <div className={style.linkContent}>{children}</div>
    </Link>
  )
)

export class Drawer extends React.Component<Props> {
  static Separator = Separator
  static Link = LinkComponent

  render() {
    const { shown, onClose, children, className } = this.props

    return (
      <div className={`${style.container} ${className || ''}`}>
        {shown && <div className={style.overlay} onClick={onClose} />}
        <div className={`${style.content} ${shown ? style.shown : ''}`}>
          {children}
        </div>
      </div>
    )
  }
}
